import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { observer } from "mobx-react-lite";
import { IQuotationItem } from "mobx-stores/_models/quotation/quotation-item";
import { useStores } from "mobx-stores/_root-store";
import { ProductNameAndActiveInfo } from "pages/common/product-name-and-active-info";
import { NumberText } from "share-components/atomics/number-text";
import { TextNoTranform } from "share-components/atomics/text-no-tranform";
import { XStickyColumnCell } from "share-components/mui-wrap/table/x-sticky-column-cell";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";

export const QuotationItemTable = observer(() => {
  const {
    quotationManagement: { quotationDetail },
  } = useStores();
  return (
    <XTablePagination hidePagination>
      <TableHead>
        <TableRow>
          <XStickyColumnCell left="0" rowSpan={2}>
            Tên hàng
          </XStickyColumnCell>
          <XStickyColumnCell rowSpan={2} left="200px">
            Mã hàng
          </XStickyColumnCell>
          <XStickyColumnCell left="350px" rowSpan={2}>
            Mã vạch
          </XStickyColumnCell>
          <TableCell rowSpan={2}>ĐVT</TableCell>
          <TableCell rowSpan={2}>SL đặt</TableCell>
          <TableCell rowSpan={2}>Đơn giá</TableCell>
          <TableCell colSpan={2} align="center">
            L/Giấy S/D
          </TableCell>
          <TableCell colSpan={3} align="center">
            Kích thước <TextNoTranform>(mm)</TextNoTranform>
          </TableCell>
          <TableCell colSpan={2} align="center">
            QC phẳng <TextNoTranform>(mm)</TextNoTranform>
          </TableCell>
          <TableCell colSpan={2} align="center">
            T/S Màu in
          </TableCell>
          <TableCell colSpan={3} align="center">
            Xử lý bề mặt
          </TableCell>
          <TableCell rowSpan={2} align="center">
            Ghi chú
          </TableCell>
          <TableCell colSpan={2} align="center">
            Đơn giá cũ 1
          </TableCell>
          <TableCell colSpan={2} align="center">
            Đơn giá cũ 2
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>L/Giấy</TableCell>
          <TableCell>Đ/L</TableCell>
          <TableCell>Dài</TableCell>
          <TableCell>Rộng</TableCell>
          <TableCell>Cao</TableCell>
          <TableCell>Khổ</TableCell>
          <TableCell>Dài</TableCell>
          <TableCell>Mặt trước</TableCell>
          <TableCell>Mặt sau</TableCell>
          <TableCell>X/L Láng</TableCell>
          <TableCell>X/L Khác</TableCell>
          <TableCell>Chi tiết X/L</TableCell>
          <TableCell>T/Năm</TableCell>
          <TableCell>Đơn giá</TableCell>
          <TableCell>T/Năm</TableCell>
          <TableCell>Đơn giá</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {quotationDetail?.items.map((x, i) => (
          <Row data-id={x.id} key={x.id} quotationItem={x}></Row>
        ))}
      </TableBody>
    </XTablePagination>
  );
});

type RowProps = {
  quotationItem: IQuotationItem;
};
const Row = observer(({ quotationItem }: RowProps) => {
  return (
    <TableRow>
      <XStickyColumnCell left="0" sx={{ minWidth: "200px" }}>
        {quotationItem?.product ? (
          <ProductNameAndActiveInfo
            product={quotationItem?.product}
          ></ProductNameAndActiveInfo>
        ) : (
          ""
        )}
      </XStickyColumnCell>
      <XStickyColumnCell sx={{ minWidth: "150px" }} left="200px">
        {quotationItem?.product?.code || ""}
      </XStickyColumnCell>
      <XStickyColumnCell left="350px" sx={{ minWidth: "150px" }}>
        {quotationItem?.product?.barcode || ""}
      </XStickyColumnCell>
      <TableCell sx={{ minWidth: "100px" }}>
        {quotationItem?.product?.unitOfCalculation || ""}
      </TableCell>
      <TableCell sx={{ minWidth: "100px" }}>
        <NumberText value={quotationItem?.amount}></NumberText>
      </TableCell>
      <TableCell sx={{ minWidth: "120px" }}>
        <NumberText value={quotationItem?.unitPrice}></NumberText>
      </TableCell>
      <TableCell sx={{ minWidth: "100px" }}>
        {quotationItem?.product?.material?.paperType || ""}
      </TableCell>
      <TableCell sx={{ minWidth: "100px" }}>
        <NumberText
          value={quotationItem?.product?.material?.gsmStandard}
        ></NumberText>
      </TableCell>
      <TableCell sx={{ minWidth: "100px" }}>
        <NumberText
          value={quotationItem?.product?.dimensionWeight?.lengthStandard}
        ></NumberText>
      </TableCell>
      <TableCell sx={{ minWidth: "100px" }}>
        <NumberText
          value={quotationItem?.product?.dimensionWeight?.widthStandard}
        ></NumberText>
      </TableCell>
      <TableCell sx={{ minWidth: "100px" }}>
        <NumberText
          value={quotationItem?.product?.dimensionWeight?.heightStandard}
        ></NumberText>
      </TableCell>
      <TableCell sx={{ minWidth: "100px" }}>
        <NumberText
          value={quotationItem?.product?.dimensionWeight?.planeSpecPaperSize}
        ></NumberText>
      </TableCell>
      <TableCell sx={{ minWidth: "100px" }}>
        <NumberText
          value={quotationItem?.product?.dimensionWeight?.planeSpecLength}
        ></NumberText>
      </TableCell>
      <TableCell sx={{ minWidth: "100px" }}>
        {quotationItem?.product?.process?.frontPrintColor || ""}
      </TableCell>
      <TableCell sx={{ minWidth: "100px" }}>
        {quotationItem?.product?.process?.backPrintColor || ""}
      </TableCell>
      <TableCell sx={{ minWidth: "100px" }}>
        {quotationItem?.product?.process?.frontPrintMatte || ""}
      </TableCell>
      <TableCell sx={{ minWidth: "100px" }}>
        {quotationItem?.product?.process?.otherHandle || ""}
      </TableCell>
      <TableCell sx={{ minWidth: "100px" }}>
        {quotationItem?.product?.process?.handleDetail || ""}
      </TableCell>
      <TableCell sx={{ minWidth: "200px" }}>
        {quotationItem?.note || ""}
      </TableCell>
      <TableCell sx={{ minWidth: "120px" }}>
        {dateTimeDisplay(quotationItem.oldUnitPriceDateFirst)}
      </TableCell>
      <TableCell sx={{ minWidth: "120px" }}>
        <NumberText value={quotationItem?.oldUnitPriceFirst}></NumberText>
      </TableCell>
      <TableCell sx={{ minWidth: "120px" }}>
        {dateTimeDisplay(quotationItem.oldUnitPriceDateSecond)}
      </TableCell>
      <TableCell sx={{ minWidth: "120px" }}>
        <NumberText value={quotationItem?.oldUnitPriceSecond}></NumberText>
      </TableCell>
    </TableRow>
  );
});
